<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">その他</div>
    <div v-if="isOpen" class="dropdown-menu">
      <router-link to="/staffShift" class="dropdown-item" @click="closeDropdown"
        >シフト入力</router-link
      >
      <router-link to="/staffMonthlySchedule" class="dropdown-item" @click="closeDropdown"
        >月間スケジュール</router-link
      >

      <router-link to="/userDaylySchedule" class="dropdown-item" @click="closeDropdown"
        >利用者スケジュール</router-link
      >

      <router-link to="/staffDaylySchedule" class="dropdown-item" @click="closeDropdown"
        >スタッフスケジュール</router-link
      >

      <router-link to="/sougeiDaylySchedule" class="dropdown-item" @click="closeDropdown"
        >送迎スケジュール</router-link
      >

      <router-link to="/workflow" class="dropdown-item" @click="closeDropdown"
        >ワークフロー</router-link
      >

      <router-link to="/workflow2" class="dropdown-item" @click="closeDropdown"
        >オリジナルワークフロー</router-link
      >

      <router-link to="/myForm" class="dropdown-item" @click="closeDropdown"
        >オリジナル画面作成</router-link
      >

      <router-link to="/svgEditor" class="dropdown-item" @click="closeDropdown"
        >SVGエディタ</router-link
      >

      <router-link to="/pdfManualUpload" class="dropdown-item" @click="closeDropdown"
        >AIマニュアル</router-link
      >

      <router-link to="/meeting" class="dropdown-item" @click="closeDropdown"
        >会議文字起こし</router-link
      >

      <router-link to="/dicomImage" class="dropdown-item" @click="closeDropdown"
        >DICOM変換</router-link
      >

      <router-link to="/receiptScanner" class="dropdown-item" @click="closeDropdown"
        >領収書スキャン</router-link
      >

      <router-link to="/receiptScanner2" class="dropdown-item" @click="closeDropdown"
        >領収書スキャン(OpenCV)</router-link
      >

      <router-link to="/receiptScanner3" class="dropdown-item" @click="closeDropdown"
        >領収書スキャン(Googli API)</router-link
      >

      <router-link to="/serviceRiyo" class="dropdown-item" @click="closeDropdown"
        >サービス利用票スキャン</router-link
      >

      <router-link to="/huggingFace" class="dropdown-item" @click="closeDropdown"
        >HuggingFace</router-link
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu3: Boolean,
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const closeDropdown = () => {
  isOpen.value = false;
};

watch(
  () => props.isOpenMenu3,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
